import {DisplayEvent} from "../../../infrastructure/models/analytics/display-event";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {WEBSITE_MODULE} from "../website-module.consts";

export class WebsiteModuleUsPopupDisplayEvent extends DisplayEvent {
  constructor() {
    super('change-country_pop-up');
  }

  get googleAnalyticsEvent(): null {
    const eventName = WEBSITE_MODULE.GOOGLE_ANALYTICS.EVENTS.display;

    return new GoogleAnalyticsEventModel(eventName)
  }
}
